// Format required by coolremote-simulator's own /api/serial endpoints:
// fixed OUI (283B96) + 2-char device-type prefix + 4 random hex chars.
export const SIMULATOR_OUI = "283B96";
export const SIMULATOR_TYPE_PREFIXES = ["00", "01", "02", "03", "10", "11", "12"];
export const SIMULATOR_SERIAL_REGEX = new RegExp(
  `^${SIMULATOR_OUI}(${SIMULATOR_TYPE_PREFIXES.join("|")})[0-9A-F]{4}$`
);

const randomHex = (length: number) => (
  Array.from({ length }, () => Math.floor(Math.random() * 16).toString(16).toUpperCase()).join("")
);

export const generateSimulatorSerial = () => {
  const prefix = SIMULATOR_TYPE_PREFIXES[Math.floor(Math.random() * SIMULATOR_TYPE_PREFIXES.length)];
  return `${SIMULATOR_OUI}${prefix}${randomHex(4)}`;
};
